module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/components/mobile-application-dev/mobile-application-icons/mobile-application-icons.component.css
// module id = ./src/app/components/mobile-application-dev/mobile-application-icons/mobile-application-icons.component.css
// module chunks = main